import { render, staticRenderFns } from "./getKurDeger.vue?vue&type=template&id=d707dd94"
import script from "./getKurDeger.vue?vue&type=script&lang=js"
export * from "./getKurDeger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports